import React, { useEffect, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { SortableContext, useSortable, arrayMove, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import Image from "react-bootstrap/Image";
import { SignatureIcon } from "../../components/SVGIcon";
import { Link } from "react-router-dom";


const Signature = {
  expert: "Participant 1 name",
  recipient: "Participant 2 name",
};

const Participant1 = {
  name: "Participant 1 name",
  companyName: "Participant 1 company",
  address: "Participant 1 address",
  city: "Participant 1 city",
  state: "Participant 1 state",
  zipCode: "Participant 1 zip code",
  country: "Participant 1 country",
  phoneNumber: "Participant 1 phone",
  email: "Participant 1 email",

}
const Participant2 = {
  name: "Participant 2 name",
  companyName: "Participant 2 company",
  address: "Participant 2 address",
  city: "Participant 2 city",
  state: "Participant 2 state",
  zipCode: "Participant 2 zip code",
  country: "Participant 2 country",
  phoneNumber: "Participant 2 phone",
  email: "Participant 2 email",
  participantName: "Participant 2 name",
  company: "Participant 2 company"
}

const ExpertiseDetails = {
  expertiseName: "Name of expertise",
  subExpertiseName: "Name of sub expertise",
}

const SessionDetails = {
  startDate: "Start date",
  startTime: "Start time",
  endDate: "End date",
  endTime: "End time",
  duration: "Total session duration",
  participant1Name: "Participant 1 name",
  participant2Name: "Participant 2 name"
}

function normalizeUrl(url) {
    if (typeof url !== "string") return url;

    // Match all http / https occurrences
    const matches = url.match(/https?:\/\//g);

    // If zero or one protocol → already valid
    if (!matches || matches.length <= 1) {
      return url;
    }

    // Keep everything from the LAST http/https occurrence
    const lastIndex = url.lastIndexOf(matches[matches.length - 1]);
    return url.slice(lastIndex);
  }

const getMappedValue = (sectionName, element) => {
  // 1️⃣ Actual value always highest priority
  if (element.value !== undefined && element.value !== null && element.value !== "") {
    return element.value;
  }

  // 2️⃣ Digital dropdown mapping
  // if (element.isDigital) {
  //   if (sectionName === "Participant1 Details") {
  //     return Participant1[element.selectedDropdownValue];
  //   }

  //   if (sectionName === "Participant2 Details") {
  //     return Participant2[element.selectedDropdownValue];
  //   }

  //   if (sectionName === "Expertise Details") {
  //     return ExpertiseDetails[element.selectedDropdownValue];
  //   }

  //   if (sectionName === "Session Details") {
  //     return SessionDetails[element.selectedDropdownValue];
  //   }
  // }

  // 3️⃣ Fallbacks
  return element.placeholder || element.selectedDropdownValue || "-";
};

const getAttachmentIcon = (attachment) => {
  if (!attachment) return "/images/image-placeholder.jpg";


  const url =
    attachment?.url ||
    attachment?.message?.url ||
    attachment?.file?.name ||
    attachment?.message || "";
  
  
  console.log("asasdasd111",url,attachment);
  const ext = url.split(".").pop()?.toLowerCase() || "";
  const name = url.split("/").pop()?.toLowerCase() || "";

  const videoExt = ["mp4", "mov", "avi", "mkv", "webm"];
  const audioExt = ["mp3", "wav", "aac", "m4a", "ogg"];
  const docExt = ["pdf", "doc", "docx", "xls", "xlsx", "ppt", "pptx", "txt", "csv"];

  if (videoExt.includes(ext)) return {name: name,icon:"/images/file-type-icon-video.svg"};
  if (audioExt.includes(ext)) return {name: name,icon:"/images/file-type-icon-audio.svg"};
  if (docExt.includes(ext)) return {name: name,icon:"/images/file-type-icon-doc.svg"};

  return {name: name,icon:"/images/file-type-icon-doc.svg"};
};

const getAttachmentUrl = (a) => a?.url ||
    a?.message?.url ||
    a?.file?.name ||
    a?.message || "";

  const getFileName = (a) => {
    const url =
    a?.url ||
    a?.message?.url ||
    a?.file?.name ||
    a?.message || "";
    if(url === ""){
      return "Attachment";
    }
    return extractFileName(url);
  };


  
const extractFileName = (url) => {
  console.log("asdasdasdasdasdasd", url);
  let lastPart = "";
  if (url && url?.url) {
    lastPart = url?.url?.substring(url?.url?.lastIndexOf("/") + 1);
  } else {
    lastPart = url?.substring(url?.lastIndexOf("/") + 1);
  }
  const fileName = lastPart.substring(lastPart.indexOf("_") + 1);
  return lastPart || "";
};

const capitalizeFirstLetter = (str) => {
  if (str.length === 0) {
    return ""; // Handle empty strings
  }
  return str.charAt(0).toUpperCase() + str.slice(1);
}

const SortableItem = ({ section }) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: section.id }); // use id, not name

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    cursor: "grab",
  };

  return (
    <li
      ref={setNodeRef}
      key={section.id} // unique key
      style={style}
      {...attributes}
      {...listeners}
      className="template-section-item"
    >
      <Image src="/images/dragger-icon.svg" width={24} height={24} alt="Dragger Icon" />
      <div className="template-section-item-button">
        {section.icon}
        {section.name}
      </div>
    </li>
  );
};



const ReportPreview = ({ data }) => {


  const [templateJson, setTemplateJson] = useState();
  useEffect(() => {
    console.log("templateJsontemplateJson", data)
    setTemplateJson(data);

  }, [data])


  return (
    <>
      {/* <div className="px-4 py-2 ">
        <h2 className="fs-20 fw-semibold mb-2">Template Name</h2>
        <p className="fs-16 text-gray-700 mb-0">{templateJson?.name}</p>
      </div> */}
      {templateJson?.schema?.map((section, index) => {


        if (section?.tag === 'Notes') {
          return <div className="p-4">
            <h2 className="fs-20 fw-semibold mb-2">{section?.name}</h2>
            {section?.fields?.map((element, row) => {
              return <p className="fs-16 text-gray-700 mb-0">{element.value || element.placeholder || element.selectedDropdownValue}</p>;
            })}

          </div>
        }

        if (section?.tag === 'Signature') {
          return <div className="p-4">
            <h2 className="fs-20 fw-semibold mb-4">{section?.name}</h2>
            <Row className="gy-4">
              {section?.fields?.map((element, row) => {
                return <Col md="6">
                  <p className="fs-14 text-gray-500 mb-1">{element.label}</p>
                  <p className="fs-16 text-gray-700 d-flex align-items-center gap-1 mb-0">
                    <Image
                      src="/images/db-icon.svg"
                      width={16}
                      height={16}
                      alt="DB Icon"
                    />
                    {Signature[element.selectedDropdownValue] || element.value || element.placeholder}
                  </p>

                  <p className="fs-14 text-gray-500 mb-1 gy-4 mt-4">Signature</p>
                  <div className="border border-gray-200 rounded-3 ratio ratio-21x9 d-block">
                    <div className="d-flex align-items-center flex-column justify-content-center gap-2">
                      {/* <SignatureIcon className="text-gray-400" size={48} /> */}
                      <p className="signature-font fs-24 text-gray-400">
                        {element.label || element.value || element.placeholder || element.selectedDropdownValue}
                      </p>
                    </div>
                  </div>
                </Col>


              })}
            </Row>
          </div>;
        }

        if (section?.tag === 'Title') {

          return <>{section?.fields?.map((element, row) => {
            return <div className="p-4">
              <div className="bg-gray-800 text-white p-3 rounded-4 fs-48 fw-bold text-center">
                {element.label || element.placeholder || element.selectedDropdownValue}
              </div>
            </div>
          })}
          </>

        }

        if (section?.tag === 'Photos') {
          return <>
            <div className="p-4">
              <h2 className="fs-20 fw-semibold mb-4">
                {section?.name}
              </h2>

              <Row className="gy-4">
                {section?.fields?.map((element, row) => {
                  if (element.type === 'arrayOfImages') {
                    return element?.value?.map(photobject => {
                      return <Col md="4">
                        <picture className="ratio ratio-1x1 d-block">
                          <Image
                            className="object-fit-cover rounded-3"
                            src={photobject.url || "/images/image-placeholder.jpg"}
                            width={150}
                            height={50}
                            alt="Header Image 1"
                          />
                        </picture>
                        <div className="mt-4">
                          <p className="fs-14 text-gray-500 mb-1">Description</p>
                          <p className="fs-16 text-gray-700 mb-0">
                            {photobject.text}
                          </p>
                        </div>
                      </Col>
                    })
                  }

                })}

              </Row>
            </div>
          </>
        }

        if (section?.tag === "Attachments") {
          return <>
            <div className="p-4">
              <h2 className="fs-20 fw-semibold mb-4">
                {section?.name}
              </h2>

              <Row className="gy-4">
                {section?.fields?.map((element, row) => {
                  if (element.type === 'ArrayOfAttachments') {

                    let value = Array.isArray(element.value) ? [...element.value] : [];

                    // Convert legacy schema ["","",""] → objects
                    value = value.map(v => {
                      if (!v) return {};
                      if (typeof v === "string") return v ? { url: v } : {};
                      return v;
                    });

                    return element?.value?.map(attachmentObject => {
                      let iconSrc = getAttachmentIcon(attachmentObject)
                      return <Col md="3" xs="6">
                        <div className="bg-gray-50 rounded-3 ratio ratio-1x1 d-block">
                          <Link
                          className="text-decoration-none"
                                                  to={getAttachmentUrl(attachmentObject)}
                                                  reloadDocument
                                                  target="_blank"
                                                >
                          <div className="h-100 d-flex align-items-center flex-column justify-content-center gap-2">
                            <Image
                              className="rounded-3 object-fit-contain"
                              src={iconSrc?.icon ?? "/images/paper-clip-icon.svg"}
                              width={48}
                              height={48}
                              alt={`Image Icon `}
                            />
                            <p className="fs-6 text-gray-400 mt-2 mb-0 text-break">{getFileName(attachmentObject)}</p>
                          </div>
                          </Link>
                        </div>
                        <p className="fs-6 text-gray-700 mt-1 mb-0 text-break">{getFileName(attachmentObject) || 'Attachment'}</p>
                      </Col>
                    })
                  }

                })}

              </Row>
            </div>
          </>
        }

        return <div className="p-4">
          <h2 className="fs-20 fw-semibold mb-4">
            {section?.name}
          </h2>
          <Row className="gy-4">
            {section?.fields?.map((element, row) => {

              if (element?.type == "arrayOfImages") {

                const images = element.value || [];
              
                return <div className="d-flex flex-wrap align-items-center gap-3 mt-3">
                  {images.map((img,idx) => (

                    <>
                      {/* Preview per slot */}
                      {img && (
                        <>
                          <div key={idx} className="file-upload-box border border-1 border-black border-grey-200 rounded-3">
                            <picture className="ratio ratio-1x1 d-block">

                              <Image
                                className="object-fit-cover"
                                src={
                                  typeof img === "string"
                                    ? normalizeUrl(img) // old stored URL
                                    : img?.preview // newly uploaded
                                }
                                width={40}
                                height={40}
                                rounded
                              />
                            </picture>
                          </div>
                        </>
                      ) || (
                        <>
                        {templateJson?.images[idx] && <div key={idx} className="file-upload-box border border-1 border-black border-grey-200 rounded-3">
                          <picture className="ratio ratio-1x1 d-block">

                            <Image
                              className="object-fit-cover"
                              src={templateJson?.images[idx]}
                              width={40}
                              height={40}
                              rounded
                            />
                          </picture>
                          </div>}
                        </>
                      )}

                    
                    </>
                  ))}

                </div>
              } else {
                if (element.type === 'text') {
                  return <Col md="3">
                    <p className="fs-14 text-gray-500 mb-1">{element.label}</p>
                    <p className="fs-16 text-gray-700 d-flex align-items-center gap-1 mb-0">
                      {element.isDigital && <Image
                        src="/images/db-icon.svg"
                        width={16}
                        height={16}
                        alt="DB Icon"
                      />}
                      {getMappedValue(section.name, element)}
                    </p>
                  </Col>
                }
              }
            })}
          </Row>
        </div>
      })}
    </>

  );
};

export default ReportPreview;
